import { createContext, useContext } from 'react';

import { type VerifiedSkillsBadgeFragment } from 'bundles/skills-common/shared/verified-skills/data/pathway-badge/__generated__/VerifiedSkillsBadgeTemplateQuery';

export type VerifiedSkillBadgeData = {
  skillPathwayName: string;
  isBadgeIssued: boolean;
  badge?: VerifiedSkillsBadgeFragment;
  loading: boolean;
};

const VerifiedSkillsBadgeDataContext = createContext<VerifiedSkillBadgeData>({
  skillPathwayName: '',
  isBadgeIssued: false,
  badge: undefined,
  loading: false,
} as VerifiedSkillBadgeData);

export const useVerifiedSkillBadgeDataContext = (): VerifiedSkillBadgeData => {
  const context = useContext(VerifiedSkillsBadgeDataContext);

  if (!context) {
    throw new Error('useVerifiedSkillBadgeDataContext must be used within a VerifiedSkillsBadgeDataProvider');
  }

  return context;
};

export default VerifiedSkillsBadgeDataContext;
